import React from "react";
import styled from "styled-components";

export default function ReviewDisplay({ reviews }) {
  if (reviews.length === 0) {
    return (
      <NoReviews>
        No reviews yet. Be the first to share your experience!
      </NoReviews>
    );
  }

  return (
    <ReviewsContainer>
      {reviews.map((review, index) => (
        <ReviewCard key={index}>
          <ReviewText>"{review.review}"</ReviewText>
          <ReviewerName>- {review.name}</ReviewerName>
        </ReviewCard>
      ))}
    </ReviewsContainer>
  );
}

const ReviewsContainer = styled.div`
  display: grid;
  gap: 20px;
  margin-top: 30px;
`;

const ReviewCard = styled.div`
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid #007bff;
`;

const ReviewText = styled.p`
  font-style: italic;
  margin-bottom: 10px;
  color: #555;
`;

const ReviewerName = styled.p`
  font-weight: bold;
  color: #333;
  margin: 0;
`;

const NoReviews = styled.div`
  text-align: center;
  color: #666;
  font-style: italic;
  margin-top: 30px;
  padding: 40px;
  background: #f8f9fa;
  border-radius: 8px;
`;